import type { DemoDiseaseDefinition } from './demoComparisonTypes';
import { DEMO_AIDA_BY_DISEASE } from './demoAidaContent';

export const DEMO_DISEASES: DemoDiseaseDefinition[] = [
  {
    id: 'ehlers-danlos',
    label: 'Ehlers-Danlos Syndrome',
    cui: 'C0013720',
    fallback: {
      academic: { genes: 50, variants: 683, studies: 18 },
      full: { genes: 123, variants: 697, studies: 365 },
    },
    aida: DEMO_AIDA_BY_DISEASE['ehlers-danlos'],
  },
  {
    id: 'parkinson',
    label: "Parkinson's Disease",
    cui: 'C0030567',
    fallback: {
      academic: { genes: 159, variants: 4208, studies: 344 },
      full: { genes: 3533, variants: 5129, studies: 18692 },
    },
    aida: DEMO_AIDA_BY_DISEASE.parkinson,
  },
  {
    id: 'type-2-diabetes',
    label: 'Type 2 Diabetes',
    cui: 'C0011860',
    fallback: {
      academic: { genes: 332, variants: 43525, studies: 376 },
      full: { genes: 5967, variants: 45115, studies: 22182 },
    },
    aida: DEMO_AIDA_BY_DISEASE['type-2-diabetes'],
  },
];

export const DEMO_PAID_PLAN = {
  title: 'Standard / Advanced',
  subtitle: 'Full dataset access + AIDA',
} as const;
